var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
//TODO: to be reviewed by sshrivastava
import { faFileUpload } from '@fortawesome/pro-regular-svg-icons';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UploadFileView } from "@yodlee/common-components";
import { Logos } from "@yodlee/common-components/dist/assets";
import { ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
import { NotificationUtils } from '@yodlee/common-components/dist/utilities';
import { Button, Col, Icon, List, Result, Row, Select, Spin, Switch, Tag, Typography } from "antd";
import Title from 'antd/lib/typography/Title';
import { cloneDeep } from "lodash";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { LabelConfigs, SettingsConfigs } from '../../configurations';
import { CommonEnums } from '../../types/enumerations';
import { BRAND } from '../../types/enumerations/commons';
import { AmplitudeEventsUtils, DataUtils } from '../../utilities';
var Option = Select.Option;
var defaultSettings = {
    autoCloseValue: "",
    sessionTimeoutValue: "",
    passwordExpiryDays: "",
    passwordExpiryNotification: "",
    userDeactivationDays: "",
    autoResolveValue: "",
    autoResolveSwitch: false
};
function getBase64(file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () { return resolve(reader.result); };
        reader.onerror = function (error) { return reject(error); };
    });
}
var isMinuteOptionVisible = function (hourValue, optionValue) {
    if ((hourValue === 4 && optionValue > 0) || (hourValue === 0 && optionValue === 0)) {
        return false;
    }
    return true;
};
var SystemSettings = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var authentication = _a.authentication, onLogoUpdate = _a.onLogoUpdate, onBannerUpdate = _a.onBannerUpdate;
    var isMD = useMediaQuery({ minWidth: ResponsiveEnums.SCREEN_SIZE.MD });
    var isXL = useMediaQuery({ minWidth: ResponsiveEnums.SCREEN_SIZE.XL });
    var isLG = useMediaQuery({ minWidth: ResponsiveEnums.SCREEN_SIZE.LG });
    var _r = useState(), logoDetails = _r[0], updateLogoDetails = _r[1];
    var _s = useState(), bannerDetails = _s[0], updateBannerDetails = _s[1];
    var _t = useState(false), clearLogoList = _t[0], toggleClearLogoList = _t[1];
    var _u = useState(false), clearBannerList = _u[0], toggleClearBannerList = _u[1];
    var _v = useState(), updateFieldName = _v[0], setUpdateFieldName = _v[1];
    var _w = useState(CommonEnums.FIELD_UPDATE_STATUS.NONE), updateFieldStatus = _w[0], setUpdateFieldStatus = _w[1];
    var _x = useState(__assign({}, defaultSettings)), settingsInfo = _x[0], updateSettingsInfo = _x[1];
    var _y = useState(__assign({}, defaultSettings)), tempSettingsInfo = _y[0], updateTempSettingsInfo = _y[1];
    var _z = useState(false), areSettingsLoading = _z[0], toggleAreSettingsLoading = _z[1];
    var _0 = useState(false), isLogoUploading = _0[0], toggleIsLogoUploading = _0[1];
    var _1 = useState(false), isFetchingLogo = _1[0], toggleIsFetchingLogo = _1[1];
    var _2 = useState(false), isBannerUploading = _2[0], toggleIsBannerUploading = _2[1];
    var _3 = useState(false), isFetchingBanner = _3[0], toggleIsFetchingBanner = _3[1];
    var _4 = useState(), logoPreview = _4[0], updateLogoPreview = _4[1];
    var _5 = useState(), bannerPreview = _5[0], updateBannerPreview = _5[1];
    var _6 = useState(), onload = _6[0], setOnload = _6[1];
    var isOtherBrandSelected = ((_b = authentication === null || authentication === void 0 ? void 0 : authentication.selectedBrand) === null || _b === void 0 ? void 0 : _b.id) && ((_c = authentication === null || authentication === void 0 ? void 0 : authentication.selectedBrand) === null || _c === void 0 ? void 0 : _c.id) !== ((_d = onload === null || onload === void 0 ? void 0 : onload.financialInstitution) === null || _d === void 0 ? void 0 : _d.id);
    useEffect(function () {
        DataUtils.onload(authentication).get(undefined, false).then(function (onload) {
            setOnload(onload);
        });
    }, []);
    useEffect(function () {
        toggleAreSettingsLoading(true);
        var settingsResp = {};
        DataUtils.settings(authentication).get()
            .then(function (setting) { return settingsResp = setting; })
            .finally(function () {
            var _a;
            toggleAreSettingsLoading(false);
            settingsResp.autoResolveSwitch = ((_a = settingsResp.autoResolveSwitch) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true';
            updateSettingsInfo(settingsResp);
            var settings = {};
            settings.autoCloseValue = settingsResp.autoCloseValue;
            settings.sessionTimeoutValue = settingsResp.sessionTimeoutValue;
            settings.passwordExpiryDays = settingsResp.passwordExpiryDays;
            settings.passwordExpiryNotification = settingsResp.passwordExpiryNotification;
            settings.userDeactivationDays = settingsResp.userDeactivationDays;
            settings.autoResolveValue = settingsResp.autoResolveValue;
            settings.autoResolveSwitch = settingsResp.autoResolveSwitch;
            updateTempSettingsInfo(settings);
        });
        toggleIsFetchingLogo(true);
        DataUtils.logo(authentication).get()
            .then(function (logo) {
            var _a;
            if ((logo === null || logo === void 0 ? void 0 : logo.status) === 204) {
                updateLogoDetails(undefined);
            }
            else {
                var fileName_1 = (_a = logo === null || logo === void 0 ? void 0 : logo.headers) === null || _a === void 0 ? void 0 : _a.filename;
                var reader = new window.FileReader();
                reader.readAsDataURL(logo === null || logo === void 0 ? void 0 : logo.data);
                reader.onload = function () {
                    var imageDataUrl = reader.result;
                    updateLogoDetails({ logo: imageDataUrl, name: fileName_1 });
                };
            }
        }).catch(function (err) { return updateLogoDetails(undefined); })
            .finally(function () { return toggleIsFetchingLogo(false); });
        toggleIsFetchingBanner(true);
        DataUtils.banner(authentication).get()
            .then(function (banner) {
            var _a;
            if ((banner === null || banner === void 0 ? void 0 : banner.status) === 204) {
                updateBannerDetails(undefined);
            }
            else {
                var fileName_2 = (_a = banner === null || banner === void 0 ? void 0 : banner.headers) === null || _a === void 0 ? void 0 : _a.filename;
                var reader = new window.FileReader();
                reader.readAsDataURL(banner === null || banner === void 0 ? void 0 : banner.data);
                reader.onload = function () {
                    var imageDataUrl = reader.result;
                    updateBannerDetails({ logo: imageDataUrl, name: fileName_2 });
                };
            }
        }).catch(function (err) { return updateBannerDetails(undefined); })
            .finally(function () { return toggleIsFetchingBanner(false); });
    }, [authentication.selectedBrand]);
    var handleSessionValueChange = function (value, durationUnit, fieldName) {
        var currentsessionTimeout = settingsInfo.sessionTimeoutValue;
        var updatedTimeoutDuration = 0;
        if (durationUnit === "hour") {
            var minutesVal = parseInt(currentsessionTimeout) % 60;
            updatedTimeoutDuration = parseInt(value) * 60 + minutesVal;
        }
        else {
            var hoursVal = Math.floor(parseInt(currentsessionTimeout) / 60);
            updatedTimeoutDuration = hoursVal * 60 + parseInt(value);
        }
        if (updatedTimeoutDuration > SettingsConfigs.MAX_SESSION_TIMEOUT)
            updatedTimeoutDuration = SettingsConfigs.MAX_SESSION_TIMEOUT;
        if (updatedTimeoutDuration < SettingsConfigs.MIN_SESSION_TIMEOUT)
            updatedTimeoutDuration = SettingsConfigs.MIN_SESSION_TIMEOUT;
        handleFieldValueChange(updatedTimeoutDuration + "", fieldName);
    };
    var logoRef = useRef();
    var bannerRef = useRef();
    var hideModal = function (type) {
        if (type === "logo") {
            if (!logoRef.current)
                return;
            logoRef.current.closeModal();
        }
        else if (type === "banner") {
            if (!bannerRef.current)
                return;
            bannerRef.current.closeModal();
        }
    };
    var handleFieldValueChange = function (value, fieldName) {
        if (value + "" === (tempSettingsInfo === null || tempSettingsInfo === void 0 ? void 0 : tempSettingsInfo[fieldName]))
            return;
        var requestObj = {};
        requestObj[fieldName] = value;
        var currentSettings = __assign({}, settingsInfo);
        currentSettings[fieldName] = fieldName === 'autoResolveSwitch' ? (value === null || value === void 0 ? void 0 : value.toLowerCase()) === 'true' : value;
        updateSettingsInfo(__assign({}, currentSettings));
        setUpdateFieldName(fieldName);
        setUpdateFieldStatus(CommonEnums.FIELD_UPDATE_STATUS.LOADING);
        DataUtils.settings(authentication).update(requestObj)
            .then(function (settings) {
            setUpdateFieldStatus(CommonEnums.FIELD_UPDATE_STATUS.UPDATE_SUCCESSFUL);
            updateTempSettingsInfo(cloneDeep(currentSettings));
        }).catch(function (error) {
            var _a, _b;
            NotificationUtils.warning("Request failed.", (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message, "ghost");
            setUpdateFieldStatus(CommonEnums.FIELD_UPDATE_STATUS.UPDATE_FAILURE);
            updateSettingsInfo(cloneDeep(tempSettingsInfo));
        }).finally(function () {
            setTimeout(function () {
                setUpdateFieldName(undefined);
                setUpdateFieldStatus(CommonEnums.FIELD_UPDATE_STATUS.NONE);
            }, 1500);
            AmplitudeEventsUtils.systemSettingsUpdate(fieldName, value);
        });
    };
    var sendFileForUpload = function (isCollapsed, file) {
        var formdata = new FormData();
        formdata.append(isCollapsed ? "logo" : "banner", file === null || file === void 0 ? void 0 : file.originFileObj, file.name);
        if (isCollapsed) {
            toggleIsLogoUploading(true);
            DataUtils.logo(authentication).update(formdata).then(function (logo) {
                var _a;
                if (logo.status === 200) {
                    updateLogoDetails(__assign(__assign({}, logoPreview), { name: "logo.".concat(((_a = logoPreview === null || logoPreview === void 0 ? void 0 : logoPreview.name) === null || _a === void 0 ? void 0 : _a.split(".").pop()) || 'ext') }));
                    if (onLogoUpdate && !isOtherBrandSelected)
                        onLogoUpdate(logoPreview);
                    // message.success(LabelConfigs.FILE_UPLOAD_SUCCESS)
                    NotificationUtils.success("Request successful.", LabelConfigs.FILE_UPLOAD_SUCCESS);
                }
                else {
                    updateLogoDetails(undefined);
                    NotificationUtils.error("Request failed.", LabelConfigs.FILE_UPLOAD_FAILED, "ghost");
                }
            }).catch(function (err) {
                updateLogoDetails(undefined);
                NotificationUtils.error("Request failed.", LabelConfigs.FILE_UPLOAD_FAILED, "ghost");
            }).finally(function () {
                hideModal("logo");
                toggleClearLogoList(true);
                toggleIsLogoUploading(false);
                updateLogoPreview(undefined);
                AmplitudeEventsUtils.systemSettingsUpdate("logo", file === null || file === void 0 ? void 0 : file.originFileObj.size);
            });
        }
        else {
            toggleIsBannerUploading(true);
            DataUtils.banner(authentication).update(formdata).then(function (logo) {
                var _a;
                if (logo.status === 200) {
                    updateBannerDetails(__assign(__assign({}, bannerPreview), { name: "banner.".concat(((_a = bannerPreview === null || bannerPreview === void 0 ? void 0 : bannerPreview.name) === null || _a === void 0 ? void 0 : _a.split(".").pop()) || 'ext') }));
                    if (onBannerUpdate && !isOtherBrandSelected)
                        onBannerUpdate(bannerPreview);
                    // message.success(LabelConfigs.FILE_UPLOAD_SUCCESS)
                    NotificationUtils.success("Request successful.", LabelConfigs.FILE_UPLOAD_SUCCESS);
                }
                else {
                    updateBannerDetails(undefined);
                    NotificationUtils.error("File upload failed.", "We’re so sorry; please try again later.", "ghost");
                }
            }).catch(function (err) {
                updateBannerDetails(undefined);
                NotificationUtils.error("File upload failed.", "We’re so sorry; please try again later.", "ghost");
            }).finally(function () {
                hideModal("banner");
                toggleClearBannerList(true);
                toggleIsBannerUploading(false);
                updateBannerPreview(undefined);
                AmplitudeEventsUtils.systemSettingsUpdate("banner");
            });
        }
    };
    var handleFileSubmit = function (fileList, isCollapsed) {
        var _a, _b;
        if (isCollapsed) {
            var fileType = (_a = fileList === null || fileList === void 0 ? void 0 : fileList[0]) === null || _a === void 0 ? void 0 : _a.type;
            if (!fileType)
                return;
            if (!supportedFileFormats.includes(fileType)) {
                // message.error(LabelConfigs.FORMAT_UNSUPPORTED_ERR);
                NotificationUtils.error("Request failed.", LabelConfigs.FORMAT_UNSUPPORTED_ERR, "ghost");
                return;
            }
            sendFileForUpload(isCollapsed, fileList === null || fileList === void 0 ? void 0 : fileList[0]);
        }
        else {
            var fileType = (_b = fileList === null || fileList === void 0 ? void 0 : fileList[0]) === null || _b === void 0 ? void 0 : _b.type;
            if (!fileType)
                return;
            if (!supportedFileFormats.includes(fileType)) {
                // message.error(LabelConfigs.FORMAT_UNSUPPORTED_ERR);
                NotificationUtils.error("Request failed.", LabelConfigs.FORMAT_UNSUPPORTED_ERR, "ghost");
                return;
            }
            sendFileForUpload(isCollapsed, fileList === null || fileList === void 0 ? void 0 : fileList[0]);
        }
    };
    var handleUploadFileChange = function (fileList, isCollapsed) {
        if ((fileList === null || fileList === void 0 ? void 0 : fileList.length) < 1) {
            if (isCollapsed)
                updateLogoPreview(undefined);
            else
                updateBannerPreview(undefined);
            return;
        }
        var file = fileList[0];
        var fileType = file === null || file === void 0 ? void 0 : file.type;
        if (!fileType)
            return;
        if (!supportedFileFormats.includes(fileType)) {
            // message.error(LabelConfigs.FORMAT_UNSUPPORTED_ERR);
            NotificationUtils.error("Request failed.", LabelConfigs.FORMAT_UNSUPPORTED_ERR, "ghost");
            if (isCollapsed)
                toggleClearLogoList(true);
            else
                toggleClearBannerList(true);
            return;
        }
        else
            handlePreview(fileList[0], isCollapsed);
    };
    var handlePreview = function (file, isCollapsed) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!file)
                        return [2 /*return*/];
                    if (!(!file.url && !file.preview)) return [3 /*break*/, 2];
                    _a = file;
                    return [4 /*yield*/, getBase64(file.originFileObj)];
                case 1:
                    _a.preview = _b.sent();
                    _b.label = 2;
                case 2:
                    if (isCollapsed) {
                        updateLogoPreview({ logo: file.url || file.preview, name: (file === null || file === void 0 ? void 0 : file.name) || "logo" });
                    }
                    else {
                        updateBannerPreview({ logo: file.url || file.preview, name: (file === null || file === void 0 ? void 0 : file.name) || "banner" });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var resetLogoComplete = function () {
        toggleClearLogoList(false);
    };
    var resetBannerComplete = function () {
        toggleClearBannerList(false);
    };
    var clearUploadedFiles = function (isCollapsed, isPreviewOnly) {
        if (isPreviewOnly) {
            if (isCollapsed) {
                toggleClearLogoList(true);
                updateLogoPreview(undefined);
            }
            else {
                toggleClearBannerList(true);
                updateBannerPreview(undefined);
            }
            return;
        }
        if (isCollapsed) {
            DataUtils.logo(authentication).remove().then(function (logo) {
                updateLogoDetails(undefined);
                if (onLogoUpdate && !isOtherBrandSelected)
                    onLogoUpdate(undefined);
                // message.success(LabelConfigs.FILE_REMOVAL_SUCCESS);
                NotificationUtils.success("Request successful.", LabelConfigs.FILE_REMOVAL_SUCCESS);
            }).catch(function (error) {
                // message.error(LabelConfigs.FILE_REMOVAL_FAILURE);
                NotificationUtils.error("Request failed.", LabelConfigs.FILE_REMOVAL_FAILURE, "ghost");
            });
        }
        else {
            DataUtils.banner(authentication).remove().then(function (logo) {
                updateBannerDetails(undefined);
                if (onBannerUpdate && !isOtherBrandSelected)
                    onBannerUpdate(undefined);
                // message.success(LabelConfigs.FILE_REMOVAL_SUCCESS);
                NotificationUtils.success("Request successful.", LabelConfigs.FILE_REMOVAL_SUCCESS);
            }).catch(function (error) {
                // message.error(LabelConfigs.FILE_REMOVAL_FAILURE);
                NotificationUtils.error("Request failed.", LabelConfigs.FILE_REMOVAL_FAILURE, "ghost");
            });
        }
    };
    var minutesLabel = isMD ? LabelConfigs.MINUTES : LabelConfigs.MINUTES_ABBREVIATION;
    var hoursLabel = isMD ? LabelConfigs.HOURS : LabelConfigs.HOURS_ABBREVIATION;
    var daysLabel = LabelConfigs.DAYS;
    var titleSpan = { span: isMD ? 11 : 24 };
    var selectorSpan = { span: isMD ? 13 : 24 };
    var sessionTimeoutHours = settingsInfo.sessionTimeoutValue ? Math.floor(parseInt(settingsInfo.sessionTimeoutValue) / 60) : "";
    var sessionTimeoutMinutes = settingsInfo.sessionTimeoutValue ? parseInt(settingsInfo.sessionTimeoutValue) % 60 : "";
    var uploadManagerProps = {
        isMobileView: !isXL,
        handleFileSubmit: handleFileSubmit,
        clearUploadedFiles: clearUploadedFiles,
        handleUploadFileChange: handleUploadFileChange
    };
    var isAdminOrSuperAdmin = ((_f = (_e = onload === null || onload === void 0 ? void 0 : onload.user) === null || _e === void 0 ? void 0 : _e.role) === null || _f === void 0 ? void 0 : _f.name) === "Admin" || (onload === null || onload === void 0 ? void 0 : onload.isSuperAdmin);
    var isTier2 = ((_h = (_g = onload === null || onload === void 0 ? void 0 : onload.financialInstitution) === null || _g === void 0 ? void 0 : _g.type) === null || _h === void 0 ? void 0 : _h.id) === BRAND.YODLEE;
    var isTier2CustomerSelected = ((_k = (_j = onload === null || onload === void 0 ? void 0 : onload.financialInstitution) === null || _j === void 0 ? void 0 : _j.type) === null || _k === void 0 ? void 0 : _k.id) === BRAND.YODLEE && ((_l = authentication === null || authentication === void 0 ? void 0 : authentication.selectedBrand) === null || _l === void 0 ? void 0 : _l.id) && ((_m = authentication === null || authentication === void 0 ? void 0 : authentication.selectedBrand) === null || _m === void 0 ? void 0 : _m.id) !== ((_o = onload === null || onload === void 0 ? void 0 : onload.financialInstitution) === null || _o === void 0 ? void 0 : _o.id);
    var isReadOnlyView = isTier2CustomerSelected && (((_q = (_p = onload === null || onload === void 0 ? void 0 : onload.user) === null || _p === void 0 ? void 0 : _p.role) === null || _q === void 0 ? void 0 : _q.name) === "Admin" && !(onload === null || onload === void 0 ? void 0 : onload.isSuperAdmin));
    return (onload ?
        (isAdminOrSuperAdmin ?
            React.createElement(Row, { className: "sys-sttngs-cntnr" },
                React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading", spin: true, style: { fontSize: "2rem" } }), spinning: areSettingsLoading },
                    React.createElement(Typography.Title, { level: 3 }, "Timeouts  and expirations"),
                    React.createElement("div", { style: { border: "1px solid #B8B8B8", borderRadius: "5px" }, className: "margin-top-md" },
                        React.createElement(Row, { className: "padding-top-md padding-left-md padding-right-md" },
                            React.createElement(Col, { xxl: 14, xl: 14, lg: 14, md: 14, sm: 24, xs: 24 },
                                React.createElement(Row, { style: { padding: "1rem" } },
                                    React.createElement(Col, __assign({}, titleSpan),
                                        React.createElement(Title, { className: "sys-sttngs-lbl font-size-md no-margin", style: { lineHeight: "36px" }, level: 4 }, "Session time out")),
                                    React.createElement(Col, __assign({}, selectorSpan),
                                        React.createElement(Row, null,
                                            React.createElement(Select, { disabled: isReadOnlyView, value: sessionTimeoutHours.toString(), className: "time-unit-selector", onChange: function (value) { return handleSessionValueChange(value, "hour", LabelConfigs.SESSION_TIMEOUT_FIELD); }, suffixIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faChevronDown }); } }) }, SettingsConfigs.hourOptions.map(function (item, indx) { return (React.createElement(Option, { key: indx, value: item.value }, item.name)); })),
                                            React.createElement(Button, { className: "time-unit-label" }, hoursLabel),
                                            React.createElement(Select, { disabled: isReadOnlyView || sessionTimeoutHours === 4, value: sessionTimeoutMinutes.toString(), className: "time-unit-selector", onChange: function (value) { return handleSessionValueChange(value, "minute", LabelConfigs.SESSION_TIMEOUT_FIELD); }, suffixIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faChevronDown }); } }) }, SettingsConfigs.minutesOptions.map(function (item, indx) { return (isMinuteOptionVisible(sessionTimeoutHours, item.value) &&
                                                React.createElement(Option, { key: indx, value: item.value }, item.name)); })),
                                            React.createElement(Button, { className: "time-unit-label" }, minutesLabel),
                                            (updateFieldName === LabelConfigs.SESSION_TIMEOUT_FIELD) && SettingsConfigs.FIELD_UPDATE_ICON[updateFieldStatus])))),
                            React.createElement(Col, { xxl: 10, xl: 10, lg: 10, md: 10, sm: 24, xs: 24 },
                                React.createElement(Row, { style: { padding: "1rem" } },
                                    React.createElement(Col, __assign({}, titleSpan),
                                        React.createElement(Title, { className: "sys-sttngs-lbl font-size-md no-margin", style: { lineHeight: "36px" }, level: 4 }, "Password expiration")),
                                    React.createElement(Col, __assign({}, selectorSpan),
                                        React.createElement(Select, { disabled: isReadOnlyView, value: settingsInfo.passwordExpiryDays, className: "time-unit-selector", onChange: function (value) { return handleFieldValueChange(value, LabelConfigs.PASSWORD_EXPIRY_DAYS); }, suffixIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faChevronDown }); } }) }, SettingsConfigs.passwordExpiryOptions.map(function (item, indx) { return (React.createElement(Option, { key: indx, value: item.value }, item.name)); })),
                                        React.createElement(Button, { className: "time-unit-label" }, daysLabel),
                                        (updateFieldName === LabelConfigs.PASSWORD_EXPIRY_DAYS) && SettingsConfigs.FIELD_UPDATE_ICON[updateFieldStatus])))),
                        React.createElement(Row, { className: "padding-left-md padding-right-md" },
                            React.createElement(Col, { xxl: 14, xl: 14, lg: 14, md: 14, sm: 24, xs: 24 },
                                React.createElement(Row, { style: { padding: "1rem" } },
                                    React.createElement(Col, __assign({}, titleSpan),
                                        React.createElement(Title, { className: "sys-sttngs-lbl font-size-md no-margin", style: { lineHeight: "36px" }, level: 4 }, "Auto close resolved service requests")),
                                    React.createElement(Col, __assign({}, selectorSpan),
                                        React.createElement(Row, null,
                                            React.createElement(Select, { value: settingsInfo.autoCloseValue, className: "time-unit-selector", onChange: function (value) { return handleFieldValueChange(value, LabelConfigs.AUTOCLOSE_SR_FIELD); }, suffixIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faChevronDown }); } }) }, SettingsConfigs.daysOptions.map(function (item, indx) { return (React.createElement(Option, { key: indx, value: item.value }, item.name)); })),
                                            React.createElement(Button, { className: "time-unit-label" }, daysLabel),
                                            (updateFieldName === LabelConfigs.AUTOCLOSE_SR_FIELD) && SettingsConfigs.FIELD_UPDATE_ICON[updateFieldStatus])))),
                            React.createElement(Col, { xxl: 10, xl: 10, lg: 10, md: 10, sm: 24, xs: 24 },
                                React.createElement(Row, { style: { padding: "1rem" } },
                                    React.createElement(Col, __assign({}, titleSpan),
                                        React.createElement(Title, { className: "sys-sttngs-lbl font-size-md no-margin", style: { lineHeight: "36px" }, level: 4 }, "Password expiration notification")),
                                    React.createElement(Col, __assign({}, selectorSpan),
                                        React.createElement(Row, null,
                                            React.createElement(Select, { disabled: isReadOnlyView, value: settingsInfo.passwordExpiryNotification, className: "time-unit-selector", onChange: function (value) { return handleFieldValueChange(value, LabelConfigs.PASSWORD_EXPIRY_NOTF_DAYS); }, suffixIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faChevronDown }); } }) }, SettingsConfigs.passwordNotificationOptions.map(function (item, indx) { return (React.createElement(Option, { key: indx, value: item.value }, item.name)); })),
                                            React.createElement(Button, { className: "time-unit-label" }, daysLabel),
                                            (updateFieldName === LabelConfigs.PASSWORD_EXPIRY_NOTF_DAYS) && SettingsConfigs.FIELD_UPDATE_ICON[updateFieldStatus]))))),
                        React.createElement(Row, { className: "padding-bottom-md padding-left-md padding-right-md" },
                            isTier2 &&
                                React.createElement(Col, { xxl: 14, xl: 14, lg: 14, md: 14, sm: 24, xs: 24 },
                                    React.createElement(Row, { style: { padding: "1rem" } },
                                        React.createElement(Col, __assign({}, titleSpan),
                                            React.createElement(Title, { className: "sys-sttngs-lbl font-size-md no-margin", style: { lineHeight: "36px" }, level: 4 }, "Auto resolve pending customer input service requests")),
                                        React.createElement(Col, __assign({}, selectorSpan),
                                            React.createElement(Row, null,
                                                React.createElement(Switch, { checked: settingsInfo.autoResolveSwitch, onChange: function (checked) { return handleFieldValueChange(checked.toString(), 'autoResolveSwitch'); }, style: { marginRight: "8px" } }),
                                                React.createElement(Select, { disabled: !settingsInfo.autoResolveSwitch, value: settingsInfo.autoResolveValue, className: "time-unit-selector", onChange: function (value) { return handleFieldValueChange(value, LabelConfigs.AUTO_RESOLVE_PENDING_CUSTOMER); }, suffixIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faChevronDown }); } }) }, SettingsConfigs.autoResolveDaysOption.map(function (item, indx) { return (React.createElement(Option, { key: indx, value: item.value }, item.name)); })),
                                                React.createElement(Button, { className: "time-unit-label" }, daysLabel),
                                                (updateFieldName === LabelConfigs.AUTO_RESOLVE_PENDING_CUSTOMER) && SettingsConfigs.FIELD_UPDATE_ICON[updateFieldStatus],
                                                (updateFieldName === 'autoResolveSwitch') && SettingsConfigs.FIELD_UPDATE_ICON[updateFieldStatus])))),
                            React.createElement(Col, { xxl: isTier2 ? 10 : 14, xl: isTier2 ? 10 : 14, lg: isTier2 ? 10 : 14, md: isTier2 ? 10 : 14, sm: 24, xs: 24 },
                                React.createElement(Row, { style: { padding: "1rem" } },
                                    React.createElement(Col, __assign({}, titleSpan),
                                        React.createElement(Title, { className: "sys-sttngs-lbl font-size-md no-margin", style: { lineHeight: "36px" }, level: 4 }, "Deactivate user due to inactivity")),
                                    React.createElement(Col, __assign({}, selectorSpan),
                                        React.createElement(Row, null,
                                            React.createElement(Select, { disabled: isReadOnlyView, value: settingsInfo.userDeactivationDays, className: "time-unit-selector", onChange: function (value) { return handleFieldValueChange(value, LabelConfigs.USER_DEACTIVATION_DAYS); }, suffixIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faChevronDown }); } }) }, SettingsConfigs.deactivationOptions.map(function (item, indx) { return (React.createElement(Option, { key: indx, value: item.value }, item.name)); })),
                                            React.createElement(Button, { className: "time-unit-label" }, daysLabel),
                                            (updateFieldName === LabelConfigs.USER_DEACTIVATION_DAYS) && SettingsConfigs.FIELD_UPDATE_ICON[updateFieldStatus]))))))),
                React.createElement(Typography.Title, { level: 3, className: "margin-top-lg" }, "Branding"),
                React.createElement("div", { style: { border: "1px solid #B8B8B8", borderRadius: "5px" } },
                    React.createElement(Row, { className: "padding-top-md padding-left-lg padding-right-lg padding-bottom-lg" },
                        React.createElement(Col, { xl: 9, style: { marginTop: "1rem", display: "flex", flexDirection: isLG ? "initial" : "column-reverse" } },
                            React.createElement(MobileViewForLogoSettings, { isMobileView: !isXL, textColumn: React.createElement(IconUploadManager, __assign({ title: "Replace iconic mark", brandIcon: logoDetails, resetUploadedFiles: clearLogoList, resetFilesComplete: resetLogoComplete, isUploading: isLogoUploading, isFetching: isFetchingLogo, iconPreview: logoPreview, description: "Upload an SVG, PNG or JPG file with similar height and width that is less than 5MB.", isCollapsed: true, ref: logoRef }, uploadManagerProps)), gap: React.createElement("div", { className: "margin-right-xl" }), menuColumn: React.createElement(SiderMenu, { isCollapsed: true, isMobileView: !isXL, brandIcon: logoDetails }) })),
                        React.createElement(Col, { xl: 1 }),
                        React.createElement(Col, { xl: 14, style: { marginTop: "1rem", display: "flex", flexDirection: isLG ? "initial" : "column-reverse" } },
                            React.createElement(MobileViewForLogoSettings, { isMobileView: !isXL, textColumn: React.createElement(IconUploadManager, __assign({ title: "Replace full lockup", brandIcon: bannerDetails, resetUploadedFiles: clearBannerList, resetFilesComplete: resetBannerComplete, isUploading: isBannerUploading, isFetching: isFetchingBanner, iconPreview: bannerPreview, description: "Upload an SVG, PNG or JPG file that is wider than tall and is less than 5MB.", ref: bannerRef }, uploadManagerProps)), gap: React.createElement("div", { className: "margin-right-xl" }), menuColumn: React.createElement(SiderMenu, { isCollapsed: false, isMobileView: !isXL, brandIcon: bannerDetails }) })))))
            :
                React.createElement(Result, { status: 403, title: "403", subTitle: "Sorry, you are not authorized." })) :
        React.createElement(Row, { type: "flex", style: { height: "80vh" }, justify: "center", align: "middle" },
            React.createElement(Col, null,
                React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading" }) }))));
};
export default SystemSettings;
var MobileViewForLogoSettings = function (_a) {
    var textColumn = _a.textColumn, menuColumn = _a.menuColumn, gap = _a.gap;
    return React.createElement(React.Fragment, null,
        menuColumn,
        gap,
        textColumn);
};
var supportedFileFormats = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/svg+xml"
];
var supportedFileExtensions = ["jpg", "jpeg", "png", "svg"];
var IconUploadManager = forwardRef(function (_a, ref) {
    var brandIcon = _a.brandIcon, handleFileSubmit = _a.handleFileSubmit, title = _a.title, isUploading = _a.isUploading, iconPreview = _a.iconPreview, isFetching = _a.isFetching, props = __rest(_a, ["brandIcon", "handleFileSubmit", "title", "isUploading", "iconPreview", "isFetching"]);
    var isCollapsed = props.isCollapsed, isMobileView = props.isMobileView, description = props.description, clearUploadedFiles = props.clearUploadedFiles, handleUploadFileChange = props.handleUploadFileChange, resetFilesComplete = props.resetFilesComplete, resetUploadedFiles = props.resetUploadedFiles;
    var _b = useState(false), isModalVisible = _b[0], setIsModalVisible = _b[1];
    useImperativeHandle(ref, function () { return ({
        closeModal: function () {
            hideModal();
        }
    }); });
    var hideModal = function () {
        setIsModalVisible(false);
    };
    var showModal = function () {
        setIsModalVisible(true);
    };
    var onFileSubmit = function (fileList) {
        handleFileSubmit(fileList, isCollapsed);
    };
    var onFileUploadChange = function (fileList) {
        handleUploadFileChange(fileList, isCollapsed);
    };
    var uploadpreview = React.createElement(React.Fragment, null,
        React.createElement(SiderMenu, { isMobileView: isMobileView, isCollapsed: isCollapsed, brandIcon: iconPreview, isUploadPreview: true }),
        React.createElement(Tag, { style: { width: "fit-content", maxWidth: "180px", position: "relative", left: "32px", display: "flex", alignItems: "center" }, closable: true, onClose: function () { clearUploadedFiles(isCollapsed, true); } },
            React.createElement("div", { style: { overflow: "hidden", textOverflow: "ellipsis" } }, iconPreview === null || iconPreview === void 0 ? void 0 : iconPreview.name)));
    return React.createElement(List, { style: { width: "250px" } },
        React.createElement(List.Item.Meta, { className: "upload-file-meta upload-custom-title", title: React.createElement("div", { onClick: !isFetching ? showModal : function () { }, className: "color-blue-5 font-size-md", style: { fontWeight: "bold", cursor: "pointer" } },
                isFetching ? SettingsConfigs.FIELD_UPDATE_ICON["LOADING"] : React.createElement(FontAwesomeIcon, { icon: faFileUpload }),
                React.createElement("span", { className: "padding-right-xs" }),
                title) }),
        React.createElement(List.Item.Meta, { className: "upload-file-meta", description: description }),
        (brandIcon === null || brandIcon === void 0 ? void 0 : brandIcon.logo) && React.createElement(List.Item.Meta, { style: { marginTop: "0.5rem" }, title: React.createElement(Tag, { closable: true, onClose: function (e) { e.preventDefault(); clearUploadedFiles(isCollapsed); } }, brandIcon === null || brandIcon === void 0 ? void 0 : brandIcon.name) }),
        React.createElement(UploadFileView, { name: "icon-upload", maxSize: 5, maxCount: 1, visible: isModalVisible, loading: isUploading, onCancel: hideModal, onSubmit: onFileSubmit, helpText: LabelConfigs.FILE_UPLOAD_INFO, onChange: onFileUploadChange, uploadPreview: iconPreview ? uploadpreview : null, supportedFileTypes: supportedFileFormats, supportedExtensions: supportedFileExtensions, shouldReset: resetUploadedFiles, didReset: resetFilesComplete }));
});
var SiderMenu = function (_a) {
    var isCollapsed = _a.isCollapsed, isMobileView = _a.isMobileView, brandIcon = _a.brandIcon, isUploadPreview = _a.isUploadPreview;
    var getLogoToRender = function () {
        if ((brandIcon === null || brandIcon === void 0 ? void 0 : brandIcon.logo) || isUploadPreview) {
            return brandIcon === null || brandIcon === void 0 ? void 0 : brandIcon.logo;
        }
        else {
            return isCollapsed ? Logos.EnvestnetYodlee : Logos.EnvestnetYodleeLabel;
        }
    };
    var collapsedWidth = 90, expandedWidth = 242, leftMargin = 20;
    return (React.createElement("div", { style: {
            alignContent: "center",
            float: isUploadPreview ? "left" : "inherit",
            width: isCollapsed ? "".concat(collapsedWidth, "px") : "".concat(expandedWidth, "px"),
            maxWidth: "100%",
            height: "90px",
            border: "1px dashed #B8B8B8",
            verticalAlign: "middle",
            display: "grid"
        }, className: "upload-menu-sider" },
        React.createElement("img", { alt: "Yodlee-label", src: getLogoToRender(), className: "padding-xs", style: {
                marginTop: "auto",
                marginRight: "auto",
                marginLeft: "auto",
                maxHeight: "45px",
                maxWidth: isCollapsed ? "".concat(collapsedWidth - leftMargin, "px") : "".concat(expandedWidth - (leftMargin * 2), "px")
            } })));
};
//# sourceMappingURL=index.js.map